import { Component ,OnInit, ElementRef,Output,EventEmitter} from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { FinancialYearService } from 'app/financial-year.service';
import { UiBreadcrumbItem } from 'app/shared/ui/models/ui-sidebar.model';

const PROCUREMENT_PATHS = new Set([
  'requisition-master',
  'request-for-quotation-master',
  'quotation-receive',
  'quotation-comparision',
  'purchase-order',
  'grn-master',
  'quality-check',
  'requisition-report',
  'purchase-order-view',
  'purchase-order-manual',
  'item-wise-report',
]);

const SALES_PATHS = new Set([
  'sales-order',
  'gsn-master',
  'invoice-details',
  'voucher-posting-supplysync',
  'voucher-posting-create-supplysync',
  'sales-purchase-return',
]);

const MASTER_PATHS = new Set([
  'vendor-master',
  'vendor-branch-master',
  'customer-master',
  'customer-branch-master',
  'contact-person-master',
]);

@Component({
  selector: 'app-supplysync-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  userName: string = '';
  branchName: string = '';
  company_name: string='';
  private toggleButton: any;
  private sidebarVisible: boolean;
  @Output() toggleSidebar = new EventEmitter<boolean>();
  isCollapsed = false;
  selectedApp: string;
  financialYears: string[] = [];
  selectedFinancialYears: string[] = [];
  breadcrumbs: UiBreadcrumbItem[] = [{ label: 'Dashboard' }];

  get userInitials(): string {
    if (!this.userName) {
      return 'AD';
    }
    return this.userName
      .split(' ')
      .filter(Boolean)
      .map(part => part.charAt(0))
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }

  constructor(location: Location, private element: ElementRef, private router: Router, private financialYearService: FinancialYearService) {
      this.location = location;
      this.sidebarVisible = false;
      let userString = localStorage.getItem('data');
     let company_name=localStorage.getItem('companyname')
      let user = JSON.parse(userString);
      this.userName = user?.name;
      this.branchName = user.branch ? user.branch.name : "";
      this.company_name=company_name;
    //   this.selectedFinancialYears = this.financialYearService.getSelectedYears();
      this.router.events.subscribe(() => {
        const currentUrl = this.router.url.split('/')[1]; // Get the first part of the route
        if (['supplysync', 'stocksphere','peoplepulse'].includes(currentUrl)) {
          this.selectedApp = currentUrl;
        } else {
          this.selectedApp = 'centralhubdashboard';
        }
        this.updateBreadcrumbs();
      });
  }

  ngOnInit() {
      this.listTitles = ROUTES.filter(listTitle => listTitle);
      this.financialYearService.availableYears$.subscribe(years => {
          this.financialYears = years;
      });
      this.financialYearService.selectedYears$.subscribe(years => {
          this.selectedFinancialYears = years || [];
      });

      const navbar: HTMLElement = this.element.nativeElement;
      this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
      this.router.events.subscribe((event) => {
          this.sidebarClose();
          var $layer: any = document.getElementsByClassName('close-layer')[0];
          if ($layer) {
              $layer.remove();
              this.mobile_menu_visible = 0;
          }
          this.updateBreadcrumbs();
      });
      this.updateBreadcrumbs();
  }

  sidebarOpen() {
      const toggleButton = this.toggleButton;
      const body = document.getElementsByTagName('body')[0];
      setTimeout(function () {
          toggleButton.classList.add('toggled');
      }, 500);

      body.classList.add('nav-open');

      this.sidebarVisible = true;
  };
  sidebarClose() {
      const body = document.getElementsByTagName('body')[0];
      this.toggleButton.classList.remove('toggled');
      this.sidebarVisible = false;
      body.classList.remove('nav-open');
  };
  sidebarToggle() {
      // const toggleButton = this.toggleButton;
      // const body = document.getElementsByTagName('body')[0];
      var $toggle = document.getElementsByClassName('navbar-toggler')[0];

      if (this.sidebarVisible === false) {
          this.sidebarOpen();
      } else {
          this.sidebarClose();
      }
      const body = document.getElementsByTagName('body')[0];

      if (this.mobile_menu_visible == 1) {
          // $('html').removeClass('nav-open');
          body.classList.remove('nav-open');
          if ($layer) {
              $layer.remove();
          }
          setTimeout(function () {
              $toggle.classList.remove('toggled');
          }, 400);

          this.mobile_menu_visible = 0;
      } else {
          setTimeout(function () {
              $toggle.classList.add('toggled');
          }, 430);

          var $layer = document.createElement('div');
          $layer.setAttribute('class', 'close-layer');


          if (body.querySelectorAll('.main-panel')) {
              document.getElementsByClassName('main-panel')[0].appendChild($layer);
          } else if (body.classList.contains('off-canvas-sidebar')) {
              document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
          }

          setTimeout(function () {
              $layer.classList.add('visible');
          }, 100);

          $layer.onclick = function () { //asign a function
              body.classList.remove('nav-open');
              this.mobile_menu_visible = 0;
              $layer.classList.remove('visible');
              setTimeout(function () {
                  $layer.remove();
                  $toggle.classList.remove('toggled');
              }, 400);
          }.bind(this);

          body.classList.add('nav-open');
          this.mobile_menu_visible = 1;

      }
  };

  getTitle(): string {
      const path = this.location.path();
      const segments = path.split('/').filter(Boolean);
      const lastSegment = segments[segments.length - 1] || '';

      for (let item = 0; item < this.listTitles.length; item++) {
          if (this.listTitles[item].path === lastSegment) {
              return this.listTitles[item].title;
          }
      }
      return 'Dashboard';
  }

  updateBreadcrumbs(): void {
      const path = this.location.path();
      const segments = path.split('/').filter(Boolean);
      const lastSegment = segments[segments.length - 1] || '';

      if (PROCUREMENT_PATHS.has(lastSegment)) {
          this.breadcrumbs = [{ label: 'Dashboard' }, { label: 'Procurement' }];
          return;
      }
      if (SALES_PATHS.has(lastSegment)) {
          this.breadcrumbs = [{ label: 'Dashboard' }, { label: 'Sales & Invoicing' }];
          return;
      }
      if (MASTER_PATHS.has(lastSegment)) {
          this.breadcrumbs = [{ label: 'Dashboard' }, { label: 'Masters' }];
          return;
      }
      this.breadcrumbs = [{ label: 'Dashboard' }];
  }
  logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('data');
      localStorage.removeItem('accesslist');
  
      // const targetOrigin = `http://pramaat1.com/#/login`;
      window.location.href = `${environment.centralDomainUrl}/#/login`;
  }
  toggleSidebarState() {
      this.isCollapsed = !this.isCollapsed;
      this.toggleSidebar.emit(this.isCollapsed);
    }

    onAppChange(value: string) {
        if (value) {
          this.router.navigate([`/${value}`]);
        }
      }

    onFinancialYearChange() {
        this.financialYearService.setFinancialYears(this.selectedFinancialYears);
    }
}
